<template>
  <t-page>

    <!-- reportId = 0, irá verificar o padrão para esta conta do tipo Dashboard -->
   <t-page-report :reportId="0" type="D"  />

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"

export default {
  mixins: [pageDefaultMixin],
  name: 'Dashboard',
  data() {
    return {
      path:"dashboard",
    }
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {


    },

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedDefault()

    await this.mountedContinued()

  },
}
</script>
<style>
.tabs_dashboard .active {
  background-color: #FFFFFF !important;
}

.tabs_dashboard .nav-link.active:hover {
  color: #3230d4 !important;
}
</style>
